// 공식 서체를 npm 패키지에서 self-host 한다. 외부 폰트 요청을 만들지 않는다.
import '@fontsource-variable/frank-ruhl-libre/index.css';
import '@fontsource-variable/noto-sans/index.css';
// Register public Chinese UI ranges before app startup; files load only when matched text uses them.
import './fonts/chinese-ui/critical.css';

let chineseFont: Promise<unknown> | undefined;

/** 중국어 선택 시 나머지 공식 글자 범위를 한 번 등록한다. 실패하면 다음 선택에서 재시도한다. */
export async function ensureLocaleFont(locale: string) {
  if (locale !== 'zh-CN') return;
  chineseFont ??= import('./fonts/chinese-ui/index.css');
  try {
    await chineseFont;
  } catch {
    chineseFont = undefined;
  }
}
